var _style, _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDbsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#001A72;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4,
    y: 4.4,
    width: 42.6,
    height: 42.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,47c11.8,0,21.3-9.5,21.3-21.3S37.1,4.4,25.3,4.4S4,13.9,4,25.7S13.5,47,25.3,47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,23.2c-0.2-0.5-0.7-0.8-2-0.7c-0.7,0.1-1.2,0.3-1.6,0.7c-0.4,0.3-0.5,0.7-0.6,1c0-0.1-0.6-2.7-0.7-3 c-0.1-0.4-1.1-3.3-1.2-3.7c-0.1-0.5-0.5-1.5-0.7-1.8c-0.2-0.6-1.5-0.8-1.7,0.3c-0.1-0.5-0.3-1.5-1-1.7c-0.7-0.1-1.4,0.2-1.4,1.3 c-0.4-0.2-1.3-0.1-1.4,0.8c0,0.5,0,1,0.1,1.5c0,0.4,0.1,0.7,0.1,1c-0.3-0.2-1.3-0.2-1.3,0.8c0,0-0.1,1.4,0,2.4c0.1,0.7,0,1-0.1,1.7 c0,0.2-0.3,1.1-0.4,1.3c0-0.2-0.3-1.1-0.4-1.3c-0.1-0.8-0.2-1-0.1-1.7c0.1-1,0-2.4,0-2.4c0-1-1-1.1-1.3-0.8c0-0.3,0.1-0.6,0.1-1 c0-0.5,0.1-1,0.1-1.5c-0.1-0.9-1-1-1.4-0.8c0-1.1-0.7-1.4-1.4-1.3c-0.7,0.1-0.9,1.2-1,1.7c-0.2-1-1.5-0.9-1.7-0.3 c-0.1,0.3-0.5,1.4-0.7,1.8c-0.1,0.5-1.1,3.4-1.2,3.7c-0.1,0.4-0.7,2.9-0.7,3c-0.1-0.3-0.2-0.7-0.6-1c-0.4-0.3-0.9-0.6-1.6-0.7 c-1.3-0.1-2,0.2-2.1,0.7c-0.1,0.4,0.1,0.8,0.4,0.9c0.3,0.1,1.1,0.4,1.5,0.6c0.4,0.2,0.4,0.4,0.4,0.7c0.1,0.3,0.3,0.5,0.4,0.9 c0.1,0.4,0.2,0.9,0.4,2.5c0.2,1.5,1.8,3.1,2,3.6c0.1,0.2,0.2,0.6,0.4,1.6c0.3,0.9,0.2,1.4,0.2,1.4c0.3,1.9,6,2.5,6.1,1.7 c0.6-3.1,1.4-2.9,1.7-4.5c0-0.1,0.2-0.6,0.2-0.8c0,0.1,0.2,0.6,0.2,0.8c0.3,1.6,1.1,1.4,1.7,4.5c0.2,0.8,5.8,0.2,6.1-1.7 c0,0,0-0.5,0.2-1.4c0.3-0.9,0.3-1.4,0.4-1.6c0.2-0.6,1.9-2.1,2-3.6c0.2-1.5,0.2-2.1,0.4-2.5c0.1-0.4,0.4-0.6,0.4-0.9 c0.1-0.3,0-0.5,0.4-0.7c0.4-0.2,1.1-0.6,1.4-0.6C38.9,24,39.2,23.6,39,23.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbsLight);
export default __webpack_public_path__ + "static/media/dbs-light.310ae51f852b7ebd2d9b6d4834c667be.svg";
export { ForwardRef as ReactComponent };